import React from 'react';
import moment from 'moment';

import Typography from '@mui/material/Typography';
import { styled, alpha } from '@mui/material/styles';
import { blue } from '@mui/material/colors';

const Message = styled('div', { shouldForwardProp: (propName) => propName !== 'isMy' })(({ theme, isMy }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  maxWidth: '80%',
  borderRadius: 8,
  marginTop: theme.spacing(1),
  padding: theme.spacing(2),
  borderBottomLeftRadius: 0,
  backgroundColor: isMy ? blue[50] : alpha(theme.palette.secondary.main, 0.3),
  ...(isMy && {
    marginLeft: 'auto',
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 0,
  }),
}));

const MessageText = styled(Typography)(() => ({
  overflowWrap: 'anywhere',
  whiteSpace: 'pre-wrap',
}));

const MessageTime = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
  fontSize: theme.typography.pxToRem(12),
  marginLeft: 'auto',
  paddingLeft: theme.spacing(1),
}));

const toHumanDate = (date) => moment(date).format('hh:mm A');

const ChatMessage = ({ data, isMy }) => (
  <Message isMy={isMy}>
    <MessageText variant="body2" className="fs-exclude">
      {data.message}
    </MessageText>
    <MessageTime>{toHumanDate(data.createdAt)}</MessageTime>
  </Message>
);
export default ChatMessage;
